export class DataCatalogViewQuery {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "sql",
            "baseName": "sql",
            "type": "string",
            "format": ""
        },
        {
            "name": "dialect",
            "baseName": "dialect",
            "type": "string",
            "format": ""
        },
        {
            "name": "parameters",
            "baseName": "parameters",
            "type": "string",
            "format": ""
        },
        {
            "name": "expectedResultShape",
            "baseName": "expectedResultShape",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DataCatalogViewQuery.attributeTypeMap;
    }
    constructor() {
    }
}
